import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Link from "@mui/material/Link";
import WelcomeName from "./WelcomeName";
import DarkModeToggle from "./DarkModeToggle";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import frDarkLogo from "../../res/FRLogo_Black.png";
import frLightLogo from "../../res/FRLogo_LightMode.png";
import { Box, IconButton } from "@mui/material";
import BreadcrumbTrail from "./BreadcrumbTrail";
import SettingsIcon from '@mui/icons-material/Settings';
import NavMenu from "./NavMenu";
import NotificationsButton from "../Notifications";
import { useAuth } from "../../utils/AuthProvider";

const NavBar = () => {
  const { cookies } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();

  const logo = theme.palette.mode === "dark" ? frDarkLogo : frLightLogo;

  return (
    <AppBar
      position="sticky"
      color="secondary"
      sx={{
        top: 0,
        zIndex: 100,
        height: { xs: "auto", sm: "80px" },
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
          gap: { xs: 0.5, sm: 1 },
          px: { xs: 1.5, sm: 2, md: 3 },
          py: { xs: 1, sm: 0 },
          minHeight: { xs: 64, sm: 80 },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            minWidth: 0,
            flex: 1,
          }}
        >
          {cookies.user && <NavMenu />}

          <Link
            component={RouterLink}
            to="/"
            color="inherit"
            sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}
          >
            <Box
              component="img"
              src={logo}
              alt="Fire Rover Logo"
              sx={{
                height: { xs: 34, sm: 46, md: 60 },
                width: "auto",
                display: "block",
              }}
            />
          </Link>

          <BreadcrumbTrail />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
          <WelcomeName />
          <DarkModeToggle />
          {cookies.user && (
            <>
              <NotificationsButton />
              <IconButton
                onClick={() => navigate(`/settings`)}
                sx={{ color: "white" }}
              >
                <SettingsIcon />
              </IconButton>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default NavBar;
